import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Phase 2 § 7 - axe-core dev-time accessibility scan. Runs ONLY in dev so it
// never ships to end users; production bundle stays untouched. Logs critical
// + serious WCAG 2.2 AA violations to the console with the offending DOM
// nodes so the team catches regressions during development.
if (process.env.NODE_ENV === "development") {
  import("@axe-core/react").then(({ default: axe }) => {
    axe(React, ReactDOM, 1000, {
      rules: [
        // Keep the noisy 'duplicate-id-aria' rule on so we never ship the
        // same data-testid wired to two elements.
        { id: "duplicate-id-aria", enabled: true },
      ],
    });
    // eslint-disable-next-line no-console
    console.info("[axe-core] WCAG 2.2 AA scan running (dev only).");
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// iter179 - Register the service worker at app load so the PWA install
// criteria (manifest + SW + HTTPS + fetch handler) are all met and Chrome
// can fire `beforeinstallprompt`. Without this the "Install SpectraLearn"
// button never becomes actionable because the SW was only being
// registered lazily by /src/lib/push.js when the user opted into
// notifications.
if (typeof window !== "undefined" && "serviceWorker" in navigator && window.location.protocol === "https:") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => { /* fail silent */ });
  });
}
